// Turns text a task is made from (a note selection, a chat message) into the
// Assign-task form's title/description. Nothing is lost: the title is the
// first line, at most 120 chars (cut with "…"), and whenever that isn't the
// whole text, the description holds all of it. Embeds (ROS/vitals grids,
// images) read as U+FFFC in quill.getText and are dropped.
export function buildTaskPrefill(selectedText) {
  const text = String(selectedText || "").replace(/￼/g, "").replace(/\r/g, "").trim();
  const lines = text.split("\n").map((l) => l.trim()).filter(Boolean);
  const first = lines[0] || "";
  const title = first.length > 120 ? `${first.slice(0, 119)}…` : first;
  const multi = lines.length > 1 || first.length > 120;
  return { title, description: multi ? lines.join("\n") : "" };
}

// A chat message as a task: the message on one line, cut at 120 chars with
// "…", as the title; the message exactly as written (line breaks and
// indentation kept, e.g. a pasted code snippet) as the description whenever
// the title isn't the whole of it.
export function buildMessageTaskPrefill(messageText) {
  const text = String(messageText || "").replace(/\r/g, "").trim();
  const oneLine = text.replace(/\s+/g, " ");
  const title = oneLine.length > 120 ? `${oneLine.slice(0, 119)}…` : oneLine;
  return { title, description: title === text ? "" : text };
}
